import Details from '@admin/components/details'
import Panel from '@admin/components/panel'
import PropTypes from 'prop-types'
import React from 'react'

const Overview = ({ email_campaign }, { admin }) => {

  const details = {
    sections: [
      {
        title: 't(Email Campaign)',
        items: [
          { label: 't(Title)', content: email_campaign.title }
        ]
      }
    ]
  }

  if(email_campaign.deleted_at !== null) {
    details.alert = { color: 'red', message: 't(This email campaign was deleted)' }
  } else if(email_campaign.status === 'canceled') {
    details.alert = { color: 'red', message: 't(This email campaign was canceled)' }
  } else if(email_campaign.status === 'paused') {
    details.alert = { color: 'pink', message: 't(This email campaign is paused)' }
  } else if(email_campaign.status === 'draft') {
    details.alert = { color: 'grey', message: 't(This email campaign is in draft mode)' }
  } else if(email_campaign.status === 'translating') {
    details.alert = { color: 'teal', message: 't(This email campaign is being translated)' }
  } else if(email_campaign.status === 'scheduled') {
    details.alert = { color: 'teal', message: 't(This email campaign is scheduled)' }
  } else if(email_campaign.status === 'queuing') {
    details.alert = { color: 'yellow', message: 't(This email campaign is being queued)' }
  } else if(email_campaign.status === 'sending') {
    details.alert = { color: 'yellow', message: 't(This email campaign is being sent)' }
  } else if(email_campaign.status === 'warming') {
    details.alert = { color: 'yellow', message: 't(This email campaign is being sent with a warming strategy)' }
  } else if(email_campaign.status === 'sent') {
    details.alert = { color: 'green', message: 't(This email campaign was sent)' }
  }

  return <Details { ...details } />

}

Overview.contextTypes = {
  admin: PropTypes.object
}

Overview.propTypes = {
  email_campaign: PropTypes.object
}

const mapPropsToPanel = (props, context) => ({
  title: 't(Overview)',
  panel: <Overview email_campaign={ props.email_campaign } />,
  ...['paused','sending'].includes(props.email_campaign.status) ? {
    tasks: {
      items: [
        {
          label: 't(Promote Campaign)',
          svg: 'award',
          show: props.email_campaign.status === 'sending',
          confirm: 't(Are you sure you want to bypass the queue and deliver these emails?)',
          request: {
            endpoint: `/api/admin/truevail/admin/deliverability/email_campaigns/${props.email_campaign.id}/promote`,
            method: 'PATCH'
          },
          onSuccess: () => context.flash.set('success', 't(Successfully promoted this email campaign)'),
          onFailure: () => context.flash.set('error', 't(Unable to promote this email campaign)')
        },
        {
          label: 't(Pause Campaign)',
          svg: 'circle_pause',
          show: props.email_campaign.status === 'sending',
          request: {
            endpoint: `/api/admin/truevail/admin/deliverability/email_campaigns/${props.email_campaign.id}/pause`,
            method: 'PATCH',
            body: {
              pause: props.email_campaign.status === 'sending'
            },
            onSuccess: () => context.flash.set('success', 't(Successfully paused this email campaign)'),
            onFailure: () => context.flash.set('error', 't(Unable to pause this email campaign)')
          }
        },
        {
          label: 't(Unpause Campaign)',
          svg: 'circle_pause',
          show: props.email_campaign.status === 'paused',
          request: {
            endpoint: `/api/admin/truevail/admin/deliverability/email_campaigns/${props.email_campaign.id}/pause`,
            method: 'PATCH',
            body: {
              pause: props.email_campaign.status === 'sending'
            },
            onSuccess: () => context.flash.set('success', 't(Successfully paused this email campaign)'),
            onFailure: () => context.flash.set('error', 't(Unable to pause this email campaign)')
          }
        }
      ]  
    }
  } : {}
})

export default Panel(null, mapPropsToPanel)
